import { fields } from "../SyncAddAccountDialog/SyncToCalendarHelper";

export const statusType = {
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
    ERROR: "ERROR"
};

export const getBackgroundColorForStatus = (enabled, isError) => {
    if(isError) return "#d8292f";
    if (enabled) return "#108C0C";
    else return "#787878";
};

export const timeInterval = (setSuccessMsgTimeOut,setSuccessMsgDetails ) => {
    const timer = setTimeout(function () {
        setSuccessMsgTimeOut(false)
        setSuccessMsgDetails({
            emailId: '',
            nickName: ''
          })
    }, 30000);
    return () => clearTimeout(timer);
}

export const calendarType = {
    GOOGLE: 'google',
    APPLE: 'apple',
    OUTLOOK: 'outlook',
};

export const calendarNames = {
    GOOGLE: 'settingsScreen.calendarGoogle',
    APPLE: 'settingsScreen.calendariOS',
    OUTLOOK: 'settingsScreen.calendarOutlook',
};

/**
 * Get the calendar Type.
 * @function
 * @param account type from the email ID object
 * @returns {string} - either 'google'/'iOS'/'Outlook' based on the account type
 */
export const getCalendarName = (type) => {
    switch (type) {
        case calendarType.GOOGLE:
            return calendarNames.GOOGLE;
        case calendarType.APPLE:
            return calendarNames.APPLE;
        case calendarType.OUTLOOK:
            return calendarNames.OUTLOOK;
        default:
            return 'N/A';
    }
}

/**
 * Get the usage Type.
 * @function
 * @param usage type from the email ID object
 * @returns {string} - either 'Personal' or 'Family' based on the usage type
 */
export const getSharingType = (type) => {
    if (type.personalUsage === true) {
        return "Personal"
    } else {
        return "Family"
    }
}

/**
 * Get the account status(either active/paused/error) for the badge.
 * @function
 * @param1 isError - boolean - true if the account contains error
 * @param2 enabled - boolean - whether the account is enabled or not from the object
 * @returns {string} - either 'ACTIVE'/'PAUSED'/'ERROR' based on the enabled status and isError Flag
 */
export const checkAccountEnabled = (enabled, isError) => {
    if(isError) return "settingsScreen.accountStatusError";
    if (enabled) return "settingsScreen.accountStatusActive";
    else return "settingsScreen.accountStatusPaused";
}

/**
 * to display only the events which are true, filtering the selected events and compare with the fields to display the desired UI name and join them together
 * @function
 * @param1 events - events object with respect to the email ID
 * @param2 enabled - boolean - whether the account is enabled or not from the email object
 * @returns the events selected from the checkboxes if the account is active or else if the account is paused return 'Sharing Paused'
 */
export const getEventsContent = (events, enabled) => {

    let tempObject = {} as any;
    Object.keys(events).forEach((v, i) => { tempObject[v] = events[v].selected; })
    const filteredValues = Object.fromEntries(Object.entries(tempObject).filter(([key, value]) => value !== false));

    if (filteredValues.all && enabled) return 'All Events';

    if (enabled) {
        const key = Object.keys(filteredValues)
        let tempObject = [] as any;
        for (let index = 0; index < key.length; index++) {
            const element = key[index];
            for (let index = 0; index < fields.length; index++) {
                if (fields[index].field === element) {
                    tempObject.push(fields[index].headerName)
                }
            }
        }
        const eventShared = Object.values(tempObject).map(function (key) {
            return key
        }).join(', ');
        return eventShared;
    }
    else
        return 'Sharing Paused'
}

/**
 * To find the active accounts count from the accounts list API.
 * @function
 * @param accountsAdded - settingsContext?.syncedCalendarData - contains the account added list
 * @returns {Number} - active accounts count
 */
export const findActiveAccounts = (accountsAdded) => {
    const activeAccountsListData = [] as any;

    accountsAdded.forEach(account => {
        if(account?.[account.emailId].enabled !== false) {
            activeAccountsListData.push(account);
        }
    })

    return activeAccountsListData.length;
}


/**
 * Sort given account array in lexical order.
 * @function
 * @param {Object} acc1 - First account object to comapre
 * @param {Object} acc2 = second account object to compare
 * @returns {Number} : 1 if account1 nickname comes first alphabetically else -1. 0, if equal
 */

const sortComparer = (acc1, acc2) => {
    const account1NickName  = acc1[acc1.emailId].accountNickName.toLowerCase();
    const account2NickName = acc2[acc2.emailId].accountNickName.toLowerCase();
    return account1NickName >  account2NickName ? 1 : account2NickName > account1NickName ? -1 : 0;
}

/**
 * Filter by usage state of the calendars.
 * @function
 * @param {Array} accounts - Array of Calendar objects
 * @returns {Array} : Array of Calendar objects where calendars with Personal usage first and then family sharing
 */
const orderByUsageAndSort = (accounts) => {
    let orderedAccountsByUsage = [];
    if(accounts?.length){
        orderedAccountsByUsage =  accounts.filter(acc => acc[acc.emailId]?.usage?.personalUsage).sort(sortComparer);
        return orderedAccountsByUsage.concat(accounts.filter(acc => acc[acc.emailId]?.usage?.sharingwithFamily).sort(sortComparer));
    }
    return orderedAccountsByUsage;
}

/**
 * Filter by enabled state of the calendars.
 * @function
 * @param {Array} cal1 - Array of Calendar objects
 * @returns {Array} : Array of Calendar objects where calendars with PAUSED state are pushed to the end
 */
export const calendarFilter = (syncCalData) => {
    let filteredCalData = [];
    if (syncCalData?.length) {
        filteredCalData = [].concat(orderByUsageAndSort(syncCalData.filter(cal => cal[cal.emailId].enabled && cal.errorCode !== notificationCodes.PAUSEDACCOUNTREMOVED))).concat(orderByUsageAndSort(syncCalData.filter(cal => !cal[cal.emailId].enabled && cal.errorCode !== notificationCodes.PAUSEDACCOUNTREMOVED)));
    }
    return filteredCalData;
}

/**
 * Checks if user has synced any calendar yet.
 * @function
 * @param {Array} cal1 - Array of Calendar objects
 * @returns {Boolean} : True if no calendar synced,  false if even one calendar is synced
 */
export const isNoAccountLinked = (syncCalData) => !syncCalData?.length

export const notificationCodes = {
    AUTHENTICATEERROR: 401,
    SYSTEMERROR: 4000,
    UNAUTHORIZEERROR: 400,
    ACCOUNTPAUSED: 419,
    PAUSEDACCOUNTREMOVED: 420,
    WARNINGDEACTIVATED: 403
};

export const getNotificationType = (errorCode) => {
    switch (parseInt(errorCode)) {
        case notificationCodes.UNAUTHORIZEERROR: case notificationCodes.AUTHENTICATEERROR: case notificationCodes.SYSTEMERROR:
            return 'error';
        case notificationCodes.ACCOUNTPAUSED: case notificationCodes.PAUSEDACCOUNTREMOVED: case notificationCodes.WARNINGDEACTIVATED:
            return 'warning';
        default:
            return ' ';
    }
}

export const getErrorBorderClasses = (errorCode) => {
    if (isError(errorCode)) {
        return  ' settings-sync-cal__error settings-sync-cal__red-border';
    } else if (errorCode === notificationCodes.ACCOUNTPAUSED || errorCode === notificationCodes.PAUSEDACCOUNTREMOVED || errorCode === notificationCodes.WARNINGDEACTIVATED) {
        return  ' settings-sync-cal__warning settings-sync-cal__yellow-border';
    } else return '';
}

export const isError = (errorCode) => {
    const parsedErrorCode = parseInt(errorCode);
    if(!errorCode) return;
    else return (parsedErrorCode === notificationCodes.UNAUTHORIZEERROR || parsedErrorCode === notificationCodes.AUTHENTICATEERROR || parsedErrorCode === notificationCodes.SYSTEMERROR);
}

export const getLastSyncOn = (lastSyncOn) => {
    return lastSyncOn ? ` ${lastSyncOn.split(' ')[0]} at ${lastSyncOn.split(' ')[1]} ET`: '';
};

export const IPADVIEWCONSTANT = {
    MAXWIDTH: 1316,
    MINWIDTH: 768, 
};

/**
 * Checks whether to show the data or not and display the API response notification.
 * @function
 * @param settingsContext 
 * @returns true if necessary data is not available
 */
export const checkDataFromAccountsApiResponse = (syncedCalendarData) => {
    let isNoData = false;
    if (!syncedCalendarData?.length) return false;
    for (let index = 0; index < syncedCalendarData.length; index++) {
        const data = syncedCalendarData[index];
        if (data?.emailId && !data?.[data.emailId]) {
            isNoData = true;
            break;
        }
    }
    return isNoData;
}

export const removeSpace = (value) => value.trim().split(/ +/).join(' ');
